import { Component } from '@angular/core';

@Component({
  selector: 'app-espectaculos-butacas',
  templateUrl: './espectaculos-butacas.component.html',
  styleUrls: ['./espectaculos-butacas.component.scss']
})
export class EspectaculosButacasComponent {}
